import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';

import { useI18n } from 'i18n';
import { TEP_RELEVANCE } from 'constants/tep';
import DatetimeField from 'core/react/general/datetime/DatetimeField';
import { tepHistoryReportSelector } from 'core/redux/selectors/reports';

import styles from './styles.module.css';

export const ReportSummary = () => {
  const { fc } = useI18n();

  const { companies, entryPasses, parameters, at } = useSelector(tepHistoryReportSelector);

  const { companies: companiesIds, entryPasses: entryPassesUris, type, timeRange } = parameters || {};

  const companiesText =
    companies && companiesIds
      ? companiesIds.map((id) => companies.find((company) => company.id === id)?.name).join(', ')
      : '';

  const entryPassesText =
    entryPasses && entryPassesUris
      ? entryPassesUris
          .map((uri) => entryPasses.find((entryPass) => entryPass.device.uri === uri)?.device.name)
          .join(', ')
      : '';

  const timeRangeText = timeRange
    ? `${moment(timeRange.since).format('YYYY-MM-DD')}~${moment(timeRange.until).format('YYYY-MM-DD')}`
    : '';

  return (
    <div className={styles.wrapper}>
      {!!at && (
        <div className={styles.generatedDate}>
          {fc('generated at')} <DatetimeField datetime={at} full />
        </div>
      )}
      <div className={styles.data}>
        {companiesText && (
          <div className={styles.row}>
            <span className={styles.title}>{fc('company')}:</span>
            <span className={styles.text}>{`${companiesText};`}</span>
          </div>
        )}
        {entryPassesText && (
          <div className={styles.row}>
            <span className={styles.title}>{fc('device')}:</span>
            <span className={styles.text}>{`${entryPassesText};`}</span>
          </div>
        )}
        {timeRangeText && (
          <div className={styles.row}>
            <span className={styles.title}>{fc('period')}:</span>
            <span className={styles.text}>{`${timeRangeText};`}</span>
          </div>
        )}
        {type && (
          <div className={styles.row}>
            <span className={styles.title}>{fc('type')}:</span>
            <span className={styles.text}>{`${TEP_RELEVANCE[type]};`}</span>
          </div>
        )}
      </div>
    </div>
  );
};
